import { render } from "./ModalPendingSuccess.vue?vue&type=template&id=fada1cdc"
import script from "./ModalPendingSuccess.vue?vue&type=script&lang=js"
export * from "./ModalPendingSuccess.vue?vue&type=script&lang=js"

import "./ModalPendingSuccess.vue?vue&type=style&index=0&id=fada1cdc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__